export type ITransactionItemResources = typeof TransactionItemResources;

export const TransactionItemResources = {
    orderIdMobileLabel: "NUMER ZAMÓWIENIA",
    complaintStatusLabel: "Ostatni status zgłoszenia:",
    purchaseAmountLabel: "WARTOŚĆ ZAKUPÓW",
    btnText: "Wyślij zgłoszenie",
    btnTextAgain: "WYŚLIJ PONOWNIE ZGŁOSZENIE",
    accountNumberLabel: "Numer konta:",
    recipientLabel: "Odbiorca:",
    trxConditionsLabel: "WARUNKI AKCEPTACJI BONUSU",
};
